import { CHANNEL_LAYOUT_VALUES, CHANNEL_VIDEO_LIST_VALUES, PLAY_TYPE_VALUES, COMPACT_SHOW_VIDEO_LIST_VALUES, INFO_POSITION_VALUES, LAYOUT_STYLE_VALUES, MAIN_ACTION_STYLE_TYPES, MAIN_ITEM_TYPE_VALUES, SHOW_INFO_VALUES, SHOW_MEDIA_TYPE_VALUES, TITLE_POSITION_VALUES } from '@wix/wix-vod-constants/app-settings';

/* Do not change these settings!
 *  These settings are used for old installations when we didn't save all settings
 *  and used defaults to complete them after load. Changes here can lead to unexpected changes on user's widgets  */

export const defaultSettingsV0 = {
  booleans: {
    enableVideosSharing: true,
    showChannelCategories: true,
    showChannelShare: true,
    showChannelTitle: true,
    showChannelInfo: false,
    showSearch: true,
    showSignIn: true,
    showChannelTags: true,
    showChannelVideos: true,
    showFullInfo: true,
    showVideoPublisherInList: true,
    showVideoTitleInList: true,
    showTitleForMainItem: true,
    showPublisherForMainItem: true
  },
  numbers: {
    videoInfoPosition: INFO_POSITION_VALUES.ON_VIDEOS,
    showInfoAction: SHOW_INFO_VALUES.ON_MOUSE_OVER,
    layoutStyle: LAYOUT_STYLE_VALUES.SQUARE,
    channelLayout: CHANNEL_LAYOUT_VALUES.CLASSIC,
    mainItemType: MAIN_ITEM_TYPE_VALUES.CHANNEL_COVER,
    mainItemTitlePosition: TITLE_POSITION_VALUES.CENTER,
    videoListVisibility: CHANNEL_VIDEO_LIST_VALUES.EXPAND_ON_CLICK,
    videosInRow: 4,
    mainItemOverlayOpacity: 35,
    showMediaType: SHOW_MEDIA_TYPE_VALUES.COVER_IMAGE,
    numberOfRows: 1,
    playType: PLAY_TYPE_VALUES.IN_FRAME,
    compactShowVideoListType: COMPACT_SHOW_VIDEO_LIST_VALUES.EXPAND_ON_CLICK,
    mainActionStyleType: MAIN_ACTION_STYLE_TYPES.ICON_WITH_TEXT
  },
  editMode: 'site'
};
//# sourceMappingURL=version-0.js.map